/*
 * 模块: 上传结果对话框
 * 职责: 显示批量上传结果的Modal
 * 依赖: Ant Design
 * 导出: showUploadResult 函数
 * 限制: 文件<280行, 函数<30行
 */

import { message, Modal, List, Space, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import type { UploadResult } from '../types';

const { Text } = Typography;

/**
 * 显示上传结果摘要
 */
export const showUploadResult = (results: UploadResult[]): void => {
  const successCount = results.filter(r => r.success).length;
  const failCount = results.filter(r => !r.success).length;

  if (failCount === 0) {
    message.success(`✓ 成功上传并处理 ${successCount} 个周期！`, 3);
    return;
  }

  Modal.info({
    title: `批量上传完成 - 成功 ${successCount} 个，失败 ${failCount} 个`,
    width: 600,
    content: (
      <div>
        <p
          style={{
            marginBottom: 16,
            fontSize: 14,
            fontWeight: 500,
            color: successCount > 0 ? '#52c41a' : '#ff4d4f'
          }}
        >
          {successCount > 0 && `✓ 已成功上传并处理 ${successCount} 个周期`}
          {failCount > 0 && (successCount > 0 ? ` | ` : '')}
          {failCount > 0 && `✗ ${failCount} 个文件上传失败`}
        </p>
        <List
          size="small"
          dataSource={results}
          renderItem={(item) => (
            <List.Item>
              <Space>
                {item.success ? (
                  <CheckCircleOutlined style={{ color: '#52c41a' }} />
                ) : (
                  <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
                )}
                <Text strong>{item.file}</Text>
                <Text type="secondary">{item.message}</Text>
              </Space>
            </List.Item>
          )}
        />
      </div>
    )
  });
};

